import { useEffect, useState } from "react";
import url from "../ServerUrl";

const Paramedics = () => {
    const [paramedics, setParamedics] = useState([]);
    const [name, setName] = useState("");
    const [editing, setEditing] = useState(null);
    const [message, setMessage] = useState("");

    const request = async (body) => {
        const response = await fetch(`${url}/resolveQuery`, {
            method: "POST",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error("Request failed");
        return response.json();
    };

    const loadParamedics = async () => {
        try {
            const data = await request({ query: "getParamedics" });
            setParamedics(Array.isArray(data) ? data : []);
        } catch { setMessage("Unable to load paramedics. Please refresh and try again."); }
    };

    useEffect(() => { loadParamedics(); }, []);

    const addParamedic = async (event) => {
        event.preventDefault();
        try { await request({ query: "addParamedic", name }); setName(""); setMessage("Paramedic added successfully."); await loadParamedics(); }
        catch { setMessage("Paramedic could not be added."); }
    };

    const updateParamedic = async (event) => {
        event.preventDefault();
        try { await request({ query: "updateParamedic", ...editing }); setEditing(null); setMessage("Paramedic updated successfully."); await loadParamedics(); }
        catch { setMessage("Paramedic could not be updated."); }
    };

    const deleteParamedic = async (paramedic) => {
        if (!window.confirm(`Delete ${paramedic.name}?`)) return;
        try { await request({ query: "deleteParamedic", paramedicid: paramedic.paramedicid }); setMessage("Paramedic deleted successfully."); await loadParamedics(); }
        catch { setMessage("Paramedic could not be deleted."); }
    };

    return <div className="admin_ambulances drivers-page">
        <div className="drivers-heading"><div><h1>Paramedics</h1><p className="drivers-count">Database paramedics ({paramedics.length})</p></div><button className="drivers-refresh-button" onClick={loadParamedics} type="button">↻ Refresh</button></div>
        {message && <p className="drivers-message" role="status">{message}</p>}
        <form className="paramedic-add-form" onSubmit={addParamedic}><input value={name} onChange={(event) => setName(event.target.value)} placeholder="Paramedic name" required /><button type="submit">＋ Add paramedic</button></form>
        <div className="ambulance_table drivers-table-wrap"><table className="history_table drivers-table"><thead><tr className="history_table_header"><th>ID</th><th>Name</th><th>Edit</th><th>Delete</th></tr></thead><tbody>
            {paramedics.map((paramedic) => <tr key={paramedic.paramedicid}><td>{paramedic.paramedicid}</td><td>{paramedic.name}</td><td><button className="driver-action-button" title="Edit paramedic" aria-label={`Edit ${paramedic.name}`} onClick={() => setEditing({ ...paramedic })} type="button">✎</button></td><td><button className="driver-action-button driver-delete-button" title="Delete paramedic" aria-label={`Delete ${paramedic.name}`} onClick={() => deleteParamedic(paramedic)} type="button">⌫</button></td></tr>)}
            {paramedics.length === 0 && <tr><td className="drivers-empty" colSpan="4">No paramedics found in the local database.</td></tr>}
        </tbody></table></div>
        {editing && <div className="driver-edit-panel" role="dialog" aria-modal="true"><form onSubmit={updateParamedic}><div className="driver-edit-heading"><h2>Edit Paramedic</h2><button type="button" onClick={() => setEditing(null)} aria-label="Close">×</button></div><label className="paramedic-edit-label">Name<input required value={editing.name || ""} onChange={(event) => setEditing({ ...editing, name: event.target.value })} /></label><div className="driver-form-actions"><button type="button" onClick={() => setEditing(null)}>Cancel</button><button type="submit">Save changes</button></div></form></div>}
    </div>;
};

export default Paramedics;
